import { Component, ViewContainerRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from "../environments/environment";
import { AuthService } from './core/auth/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { AppService } from './app.service';
import { Router } from '@angular/router';
import { RdUser } from './core/user/user.types';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

    static logoUrl: String;

    currentUserProfile: RdUser = undefined;
    userProfiles: any[] = [];

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        public vcRef: ViewContainerRef,
        private titleService: Title,
        private _authService: AuthService,
        private _appService: AppService,
        private _router: Router) {

        let title = 'Rugged Hub';
        if (environment.buildEnv) {
            title += ` - ${environment.buildEnv}`;
        }
        titleService.setTitle(title);

        let favIcon16: HTMLLinkElement = document.querySelector('#appIcon16');
        let favIcon32: HTMLLinkElement = document.querySelector('#appIcon32');

        if (environment.buildEnv.includes('Dev')) {
            if (favIcon16 || favIcon32) {
                // favIcon16.href = favIcon16.href.replace("favicon-16x16.png", "favicon-dev-16x16.png");
                // favIcon32.href = favIcon32.href.replace("favicon-32x32.png", "favicon-dev-32x32.png");
                AppComponent.logoUrl = 'logo-dev.png';
            }
        }
        else if (environment.buildEnv.includes('Tester')) {
            if (favIcon16 || favIcon32) {
                favIcon16.href = favIcon16.href.replace("favicon-16x16.png", "favicon-tester-16x16.png");
                favIcon32.href = favIcon32.href.replace("favicon-32x32.png", "favicon-tester-32x32.png");
                AppComponent.logoUrl = 'logo-staging.png';
            }
        }
        else if (environment.buildEnv.includes('Staging')) {
            if (favIcon16 || favIcon32) {
                // favIcon16.href = favIcon16.href.replace("favicon-16x16.png", "favicon-staging-16x16.png");
                // favIcon32.href = favIcon32.href.replace("favicon-32x32.png", "favicon-staging-32x32.png");
                AppComponent.logoUrl = 'logo-staging.png';
            }
        }
    }

    title = 'rugged-hub';

    ngOnInit() {

        this._appService.userProfiles$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(async (userProfiles) => {
                if (userProfiles) {
                    this.currentUserProfile = this._authService.user;
                    this.userProfiles = userProfiles;
                    this.userProfiles?.forEach((profile) => {
                        if (profile.id === this.currentUserProfile?.id) {
                            if (profile.disabled === true) {
                                this._router.navigate(['/sign-out']);
                            }
                        }
                    })
                }
            })
    }

    ngOnDestroy() {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
